import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Stack, Text } from '@mantine/core';
import useResponsive from 'src/hooks/useResponsive';
import useAdminSettings from 'src/hooks/useAdminSettings';
import { StyledContainer } from 'src/components/common/StyledComponents/Container';
import { StyledContainerInset } from 'src/components/common/StyledComponents/BackgroundContainer';
import { formatDate } from 'src/utils/helpers';
import { AppButton } from 'src/components/common/Buttons/AppButton';
import { IconButton } from 'src/components/common/Buttons/IconButton';
import { FocusButton } from 'src/components/common/Buttons/FocusButton';
import { adminService } from 'src/services/services/admin/admin.api';
import { ResponseKind } from 'src/services/services/MainService';
import { sendFailureNotification, sendSuccessNotification } from 'src/utils/notifications';
import { NotificationTypes } from 'src/enums/Notifications';
import { Notifications } from '@mantine/notifications';


const ComplaintDetail = () => {
  const { selectedComplaints, resolveComplaint } = useAdminSettings();
  const {isMobile} = useResponsive()
  const complaint = selectedComplaints;
  const { backgroundColor, backgroundColorExterior } = useResponsive();

  const updateComplaint = async (id: number) => {
    const res = await adminService.resolveComplaints(id)
    if(res.kind == ResponseKind.OK){
      sendSuccessNotification(NotificationTypes.resolveComplaint, "Complaint resolved")
      resolveComplaint()
    }else{
      sendFailureNotification(NotificationTypes.resolveComplaint, "Complaint wasn't resolved")
    }
  }

  return (
    <StyledContainer theme={{ backgroundColor: backgroundColorExterior }}>
      <StyledContainerInset theme={{ backgroundColor: backgroundColor }}>
      <Notifications
          position={isMobile ? "top-center" : "bottom-right"}
          limit={isMobile ? 1 : 5}
       />
        <Card>
          <Stack>
            <div className='flex flex-row w-full justify-between'>
            <Text size="xl" weight={700}>Complaint Details</Text>
            <Button disabled={complaint.status == "resolved"} onClick={() => updateComplaint(complaint?.id)}>Resolve</Button>
              </div>
            <Text>ID: {complaint?.id}</Text>
            <Text>Parent Email: {complaint?.parent_email}</Text>
            <Text>Child Username: {complaint?.child_username}</Text>
            <div className=' flex flex-row gap-2'>
            <Text>Status:</Text>
            <Card bg={"blue"} p={2} px={8} radius={"md"}><Text className=' text-white'>{complaint?.status}</Text></Card>
              </div>
            <Text>Created At: {formatDate(complaint?.created_at)}</Text>
            <Card withBorder>
              <Text weight={700}>Flagged Message:</Text>
              <Text>{complaint?.flagged_message}</Text>
            </Card>
            {complaint?.previous_messages?.length > 0 ? <Text weight={700}>Previous Messages:</Text> : <Text weight={700}>No previous messages</Text>}
            <div className= 'h-[300px] overflow-y-auto'>
            {complaint?.previous_messages?.map((msg, index) => (
              <Card key={index} withBorder>
                <Text weight={600}>{msg.role}:</Text>
                {msg.content.startsWith('{"file_name":') ? (
                  <img 
                    src={JSON.parse(msg.content).image_url} 
                    alt={JSON.parse(msg.content).file_name}
                    className="max-w-[400px] h-auto"
                  />
                ) : (
                  <Text>{msg.content}</Text>
                )}
                <Text size="xs" color="dimmed">Sent at: {formatDate(String(msg?.created_at))}</Text>
              </Card>
            ))}
            </div>

          </Stack>
        </Card>
      </StyledContainerInset>
    </StyledContainer>
  );
};

export default ComplaintDetail;